/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationRequest as ModelsV4ApplicationApplicationRequest } from '../../models/Models/v4/Application/application-request';
import { ApplicationUpdateVehicleResponseBaseResponse as ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse } from '../../models/Models/v4/Application/Public/application-update-vehicle-response-base-response';

export interface V4PublicApplicationVehicleApplicationIdPut$Plain$Params {
  applicationId: string;
      body?: ModelsV4ApplicationApplicationRequest
}

export function v4PublicApplicationVehicleApplicationIdPut$Plain(http: HttpClient, rootUrl: string, params: V4PublicApplicationVehicleApplicationIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v4PublicApplicationVehicleApplicationIdPut$Plain.PATH, 'put');
  if (params) {
    rb.path('applicationId', params.applicationId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>;
    })
  );
}

v4PublicApplicationVehicleApplicationIdPut$Plain.PATH = '/v4/public/application/vehicle/{applicationId}';
